<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row clas="mb-5">
        <v-col cols="6">
          <h3>Consistência de Estoque</h3>
        </v-col>
        <v-col>
          <v-text-field
            append-icon="mdi-magnify"
            label="Buscar"
            dense
            single-line
            hide-details
            outlined
            color="primary"
            v-model="search"
          ></v-text-field>
        </v-col>
        <v-col class="text-right" cols="2">
          <v-btn 
            depressed 
            color="primary" 
            class="text-center mr-1" 
            :disabled="!products.length"
            :dark="products.length" 
            @click="downloadCSV()" 
            block
          >
            <v-icon small class="mx-2">mdi-magnify</v-icon>
            Exportar CSV
          </v-btn>
        </v-col>
      </v-row>
      <v-divider class="my-3"></v-divider>

      <v-data-table :items="products" :headers="headers" :search="search" :loading="loading">
        <template v-slot:[`item.stockAmount`]="{ item }">
          <div label :class="getClass(item)">
            {{ item.stockAmount }}
          </div>
        </template>
        <template v-slot:[`item.quantity`]="{ item }">
          <div>
            {{ item.quantity }}
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

export default {
  name: 'Integrations',
  data: () => ({
    products: [],
    headers: [
      { text: 'Sku ID', value: 'skuId' },
      { text: 'Nome', value: 'sellerProductName' },
      { text: 'Estoque FRESNOMAQ', value: 'quantity' },
      { text: 'Estoque Hubble', value: 'stockAmount' },
    ],
    search: null,
    loading: false,
  }),
  methods: {
    loadProducts() {
      this.loading = true
      const url = `${baseApiUrl}/product/stock`
      axios
        .get(url)
        .then((res) => {
          this.products = res.data
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    getClass(item) {
      if (item.quantity === item.stockAmount) {
        return 'green'
      } else {
        return 'red'
      }
    },
    downloadCSV() {
      const data = this.products
      const fileName = 'Consistencia-de-estoque'
      const csv = this.convertArrayOfObjectsToCSV(data)
      const link = document.createElement('a')
      link.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
      link.download = fileName + '.csv'
      link.click()
    },
    convertArrayOfObjectsToCSV(data) {
      const columnDelimiter = ','
      const lineDelimiter = '\n'
      const keys = Object.keys(data[0])

      let result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter

      data.forEach((item) => {
        let ctr = 0
        keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })

      return result
    },
  },
  mounted() {
    this.loadProducts()
  },
}
</script>
<style scoped>
.green {
  text-align: center;
  background: green;
  width: 100%;
  padding: 4px;
  border-radius: 4px;
}
.red {
  text-align: center;
  background: red;
  width: 100%;
  padding: 4px;
  border-radius: 4px;
}
</style>
